function NotFoundPage() {
  return (
    <section className="not_found_wrapper">
      <div className="not_found_text">
        <h1>404</h1>
        <h2>oops! page not found</h2>
        <p>The page you looking for doesn't exist or an other error occurred.</p>
      </div>
      <img src="/assets/images/undraw_location-search_nesh 1.svg" alt="" className="not_found_image" />
    </section>
  );
}

export default NotFoundPage;
